import { c as _c } from "react/compiler-runtime";
import React, { Children } from "react";
import { Box, VStack, Grid, GridItem } from "@chakra-ui/react";
interface CardContainerProps {
  padded?: boolean;
  stackDirectionResponsive?: boolean;
  children: React.ReactNode;
}
export const CardContainer = t0 => {
  const $ = _c(4);
  const {
    padded: t1,
    stackDirectionResponsive: t2,
    children
  } = t0;
  const padded = t1 === undefined ? true : t1;
  const stackDirectionResponsive = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== children || $[1] !== padded || $[2] !== stackDirectionResponsive) {
    t3 = stackDirectionResponsive ? <Grid zIndex="docked" w="full" templateRows="repeat(2, 1fr)" templateColumns={{
      base: "1fr",
      lg: "repeat(2, minmax(0, 1fr))"
    }} gap="3.5">{Children.map(children, _temp)}</Grid> : <Box px={padded ? "8" : "0"} py={padded ? "8" : "0"} zIndex="docked" w="full"><VStack gap="3.5">{children}</VStack></Box>;
    $[0] = children;
    $[1] = padded;
    $[2] = stackDirectionResponsive;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(child, index) {
  return <GridItem key={index}><Box>{child}</Box></GridItem>;
}